import { IComponentOptions } from 'angular';
import { RegentsPrepWizardCtrl } from './regents-prep-wizard.controller';

export const RegentsPrepWizardComponent: IComponentOptions = {
  bindings: {
    initialWizardState: '<',
    studentSupports: '<',
    schoolSupports: '<',
    currentSchool: '<',
    currentUser: '<',
  },
  controller: RegentsPrepWizardCtrl,
  template: require('./regents-prep-wizard.html'),
};
